<template>
    <ResourceInput
        label="Summary bullets title"
        attribute="summaryBulletsTitle"
    />
</template>
